const EMAIL_LOOKS_VALID_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * A loose check, deliberately not the server's own validation: it only gates when the panel bothers
 * calling `resolveAuthenticationModes` for the SSO preselection (§8.6). A false positive costs one
 * network call the server will reject on submit anyway; a false negative just delays the preselection.
 */
const isEmailLikelyValid = (email: string): boolean => EMAIL_LOOKS_VALID_PATTERN.test(email);

export default isEmailLikelyValid;
